'use client';

import { ErrorOverlay } from '@/components/ErrorOverlay/ErrorOverlay';
import { useErrorStore } from '@/stores/errorStore';

export function ErrorOverlayRoot(): React.ReactNode {
  const { errors } = useErrorStore();
  const error = errors[0];

  if (!errors.length) {
    return null;
  }

  return <ErrorOverlay code={error.code} targetId={error.targetId} />;
}
